import { render, staticRenderFns } from "./ServiceRequestList.vue?vue&type=template&id=171438a4&"
import script from "./ServiceRequestList.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171438a4')) {
      api.createRecord('171438a4', component.options)
    } else {
      api.reload('171438a4', component.options)
    }
    module.hot.accept("./ServiceRequestList.vue?vue&type=template&id=171438a4&", function () {
      api.rerender('171438a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/requests/ServiceRequestList.vue"
export default component.exports